import type { ReactNode } from "react"
import { Button } from "../ui/Button.js"

interface CoachmarkProps {
  title: string
  description: string
  onDismiss: () => void
  children: ReactNode
}

/**
 * Wraps a piece of UI and overlays a one-time explanation the first time
 * it's shown (paired with useFirstVisit). Non-blocking: the underlying
 * UI is still visible and usable, this just calls out the non-obvious
 * part with an arrow-anchored card.
 */
export function Coachmark({ title, description, onDismiss, children }: CoachmarkProps) {
  return (
    <div style={{ position: "relative" }}>
      {children}
      <div
        role="dialog"
        aria-label={title}
        style={{
          position: "absolute",
          top: "calc(100% + var(--space-2))",
          left: 0,
          zIndex: 50,
          width: 280,
          background: "var(--bg-surface-raised)",
          border: "1px solid var(--brand-primary)",
          borderRadius: "var(--radius-md)",
          boxShadow: "var(--shadow-lg)",
          padding: "var(--space-4)",
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-2)",
          animation: "mc-coachmark-in var(--duration-medium) var(--ease-out)",
        }}
      >
        <strong style={{ fontSize: "var(--text-sm)" }}>{title}</strong>
        <p style={{ fontSize: "var(--text-sm)", color: "var(--text-muted)" }}>{description}</p>
        <Button size="sm" variant="secondary" onClick={onDismiss} style={{ alignSelf: "flex-end" }}>
          Entendido
        </Button>
      </div>
      <style>{`
        @keyframes mc-coachmark-in {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
